import { useQuery } from "@tanstack/react-query";
import { XMLParser } from "fast-xml-parser";

const SHARE_URL = `https://essilor.symex.be/finance.xml`;

const useShareWidget = () => {
  return useQuery({
    queryKey: ["share-widget"],
    queryFn: async () => {
      const response = await fetch(SHARE_URL);
      if (!response.ok) {
        throw new Error(`Error calling ${SHARE_URL}: ${response.status} ${response.statusText}`);
      }
      return response.text();
    },
    refetchOnMount: false,
    keepPreviousData: true,
    select: (XMLdata) => {
      const parser = new XMLParser();
      const xmlDoc = parser.parse(XMLdata);
      return xmlDoc.Actions.Essilor;
    },
    onError: (err) => {
      console.error("Error loading share price: ", err);
    },
  });
};

export default useShareWidget;
